import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { DataContainer, ErrorWithLabel } from 'components/DataContainer';
import { getEasyBasketOperation } from 'domains/easyBasket/EasyBasket.store';
import { OperationItem } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/OperationsSection.styled';
import { IconWrapper } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/PartsSelection.styled';
import { Flex, Text, WithTooltip } from 'UI';
import { isError } from 'utils';

const OperationSelector = ({
  operationId,
  selectedOperationId,
  onSelectOperation,
}: {
  operationId: string;
  selectedOperationId?: string;
  onSelectOperation: (operationId: string) => void;
}) => {
  const { t } = useTranslation();
  const operation = useSelector((state: RootState) => getEasyBasketOperation(state, operationId));
  const { interventionQuantity, designation } = operation?.data ?? {};
  const isSelectable = !isError(operation?.searchStatus);

  const renderInterventionQuantity = () => {
    const quantityNum = parseFloat(interventionQuantity || '0');

    if (isNaN(quantityNum) || quantityNum < 2) {
      return null;
    }

    return (
      <WithTooltip
        title={t('catalog.easy_basket.intervention_quantity.relates_to_operations', 'Relates to several operations')}
      >
        <IconWrapper>
          <Text type="lg" bold disableGutter cursor={'pointer'}>
            {`x${quantityNum}`}
          </Text>
        </IconWrapper>
      </WithTooltip>
    );
  };

  return (
    <OperationItem
      align={'center'}
      padding={16}
      onClick={() => isSelectable && onSelectOperation(operationId)}
      isActive={operationId === selectedOperationId}
    >
      <DataContainer
        data={operation?.searchStatus}
        ErrorState={() => (
          <ErrorWithLabel
            label={t('catalog.easy_basket.loading_operations_error', 'Failed to load operation {{operationId}}.', {
              operationId,
            })}
          />
        )}
      >
        <Flex justify={'space-between'}>
          <Text type="lg" bold disableGutter transform={'capitalize'} cursor={'pointer'}>
            {designation ?? operationId}
          </Text>
          {renderInterventionQuantity()}
        </Flex>
      </DataContainer>
    </OperationItem>
  );
};

export default OperationSelector;
